import { useEffect, useState } from 'react';

/**
 * custom hook to detect the width and height of the current window in px
 *
 * @returns {Object} - window size object with width and height parameters in px
 */
const useDetectWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth || document.documentElement.clientWidth,
      height: window.innerHeight || document.documentElement.clientHeight,
    });
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export { useDetectWindowSize };
